import { Box, Grid, Tab, Tabs } from '@mui/material';
import { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import { COLOR5 } from '../../constants';
import { LayoutStyles as classes } from './LayoutStyles';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      //   {...other}
    >
      {value === index && <Box marginY="20px">{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function CommonTab({ checkingProduct, savingProduct }) {
  const [value, setValue] = useState(0);
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);

  const { productTabVal, setProductTabVal, theme } = leadGenerationContext;

  const handleChange = (event, newValue) => {
    setProductTabVal(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
        <Tabs
          centered
          value={productTabVal}
          onChange={handleChange}
          aria-label="basic tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: theme?.palette?.orientalPrimary?.main,
            },
          }}
        >
          <Tab
            style={{ ...classes.tab, color: theme?.palette?.orientalPrimary?.main }}
            label={t('Libre Account', {
              defaultValue: 'Libre Account',
            })}
            {...a11yProps(0)}
          />
          <Tab
            style={{ ...classes.tab, color: theme?.palette?.orientalPrimary?.main }}
            label={t('Ahorra Account', {
              defaultValue: 'Ahorra Account',
            })}
            {...a11yProps(1)}
          />
        </Tabs>
      </Box>
      <TabPanel value={productTabVal} index={0}>
        {savingProduct()}
      </TabPanel>
      <TabPanel value={productTabVal} index={1}>
        {checkingProduct()}
      </TabPanel>
    </Box>
  );
}
CommonTab.propTypes = {
  checkingProduct: PropTypes.func,
  savingProduct: PropTypes.func,
};
